import { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import { useParams } from '@tanstack/react-router';
import moment from 'moment';
import AgreementService from '@services/AgreementService';
import Spinner from '@components/Spinner';

const SingleAgreement = () => {
  const [loading, setLoading] = useState(true);
  const [agreement, setAgreement] = useState<Agreement>();
  const params = useParams({ strict: false });

  useEffect(() => {
    if (params?.type) {
      setLoading(true);
      AgreementService.getOne(params.type).then((data) => {
        setAgreement(data);
        setLoading(false);
      });
    }
  }, [params?.type]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <Row style={{ padding: 20 }} className="agreement-page">
      <Col span={24}>
        {agreement && <div dangerouslySetInnerHTML={{ __html: agreement.text }} />}
        {agreement && (
          <div>
            <p>Last updated: {moment(agreement.updatedAt).format('L')}</p>
          </div>
        )}
      </Col>
    </Row>
  );
};

export default SingleAgreement;
